import { useTour } from '@reactour/tour';
import {
  mockAnalysisResult,
  mockAnalysisImage,
} from '@/components/Tutorial/mocks/analysisResultMock';
import { useMockState } from '@/components/Tutorial/mocks/mockState';
import type { AnalysisTabs } from '../types/common.types';
import type {
  FileResultResponse,
  FileImageResponse,
  FileNotesResponse,
  FileAnomalyResponse,
  FileMRZResponse,
} from '../types/api.types';

interface UseMockAnalysisReturn {
  resultData: FileResultResponse | undefined;
  isResultLoading: boolean;
  imageData: FileImageResponse | undefined;
  downloadData: Blob | undefined;
  anomalyData: FileAnomalyResponse | undefined;
  mrzData: FileMRZResponse | undefined;
  notesData: FileNotesResponse | undefined;
}

export const useMockAnalysis = (
  _pageIndex: number,
  _toggle: AnalysisTabs
): UseMockAnalysisReturn => {
  const { isOpen } = useTour();
  const { isFavorite } = useMockState();

  const isResultLoading = !isOpen;

  if (isOpen) {
    const mockResult = {
      ...mockAnalysisResult,
      favori: isFavorite,
    };

    return {
      resultData: mockResult,
      isResultLoading,
      imageData: mockAnalysisImage,
      downloadData: undefined,
      anomalyData: undefined,
      mrzData: undefined,
      notesData: undefined,
    };
  }

  return {
    resultData: undefined,
    isResultLoading,
    imageData: undefined,
    downloadData: undefined,
    anomalyData: undefined,
    mrzData: undefined,
    notesData: undefined,
  };
};
